

import { PlayerApi } from '../../communication/player-api/PlayerApi'
import { HandHistoryList, HistoricHand } from '../../communication/PlayerApiProtocol.generated'
import {appCtx} from '../../ApplicationContext'
import {getStore, ApplicationState, dispatch} from '../Store'
import {ReduxAction, createAction} from '../ReduxUtils'
import {HandHistoryUtils} from '../../ui/profilepage/gameplay-history/hand-history/HandHistoryUtils'
import {HandHistoryRequest} from './HandHistoryReducer'

export const REQUEST_HAND_HISTORY = 'REQUEST_HAND_HISTORY'
export const RECEIVE_HAND_HISTORY = 'RECEIVE_HAND_HISTORY'
export const RECEIVE_HAND_HISTORY_ERROR = 'RECEIVE_HAND_HISTORY_ERROR'
export const SELECT_HAND = 'SELECT_HAND'
export const SELECT_HAND_DETAIL = 'SELECT_HAND_DETAIL'
export const SHOW_ALL_HANDS = 'SHOW_ALL_HANDS'
export const CLEAR_TABLE_SESSION = 'CLEAR_TABLE_SESSION'
export const CLEAR_ALL = 'CLEAR_ALL'
export const REQUEST_PREVIOUS_PAGE = 'REQUEST_PREVIOUS_PAGE'
export const REQUEST_NEXT_PAGE = 'REQUEST_NEXT_PAGE'
export const CLEAR_PREVIOUS_PAGES = 'CLEAR_PREVIOUS_PAGES'

export const PAGE_COUNT = 20


export const updateStartTime = (startTime? : number) => {
	dispatch(_updateStartTime(startTime))
}
function _updateStartTime(startTime : number) {
	return (dispatch,getState : () => ApplicationState) => {
		dispatch(clearPreviousPages())
		fetchHandHistory(startTime,getState().history.tableIntegrationId,true)
	}
}
export function clearPreviousPages() {
	return createAction(CLEAR_PREVIOUS_PAGES, {})
}

export const fetchHandHistory = (startTime?: number, tableIntegrationId?: string, descending?: boolean, nextHandIndex?: number, nextSessionIndex?: number) => {
	getStore().dispatch(_fetchTableServerHandHistory(startTime,tableIntegrationId,descending,nextHandIndex,nextSessionIndex) as any)
}

export const fetchHandHistoryDetail = (handSummary: HistoricHand) => {
	getStore().dispatch(_fetchTableServerHandHistoryDetail(handSummary.id as any))
}

export function clearAll(): ReduxAction<{}> {
	return createAction(CLEAR_ALL,{})
}

export const  goToNextPage = (handIndex? : number, sessionIndex? : number) => {
	dispatch(_goToNextPage(handIndex, sessionIndex) as any)
}

export function _goToNextPage(handIndex? : number, sessionIndex? : number) {
	return (dispatch,getState : ()=>ApplicationState) => {
		dispatch(requestNextPage(getState().history.startTime))
		fetchHandHistory(getState().history.lastHandStartTime-1, getState().history.tableIntegrationId,true, handIndex,sessionIndex)
	}
}
function requestNextPage(currentStartTime : number) : ReduxAction<number>{
	return createAction(REQUEST_NEXT_PAGE,currentStartTime)
}
export const goToPreviousPage = (handIndex? : number, sessionIndex? : number) => {
	getStore().dispatch(_goToPreviousPage(handIndex,sessionIndex) as any)
}
export function _goToPreviousPage(handIndex? : number, sessionIndex? : number){
	return (dispatch, getState : () => ApplicationState) => {
		let previousPages = getState().history.previousPages
		if (previousPages.length > 0) {
			let pageStartTime = previousPages[previousPages.length-1]
			dispatch(requestPreviousPage())
			fetchHandHistory(pageStartTime,getState().history.tableIntegrationId,true,handIndex,sessionIndex)
		} else if (getState().history.hasPreviousPage) {
			dispatch(requestPreviousPage())
			fetchHandHistory(getState().history.firstHandStartTime+1,getState().history.tableIntegrationId,false,handIndex,sessionIndex)
		}
	}
}
export function requestPreviousPage() : ReduxAction<{}>{
	return createAction(REQUEST_PREVIOUS_PAGE, {})
}

export const goToPreviousHand = () => {
	getStore().dispatch(_goToPreviousHand() as any)
}

export const goToNextHand = () => {
	getStore().dispatch(_goToNextHand() as any)
}
export function selectTableSession(tableIntegrationId) {
	_selectTableSession(tableIntegrationId)
}
function _selectTableSession(tableIntegrationId : string) {
	dispatch(clearPreviousPages())
	fetchHandHistory(0,tableIntegrationId)
}

export function showAllHands() : ReduxAction<{}>{
	return createAction(SHOW_ALL_HANDS, {})
}
export const clearTableSession = ()=>{ getStore().dispatch(_clearTableSession() as any)}
export function _clearTableSession() {
	return (dispatch,getState : ()=>ApplicationState) => {
		if (getState().history.tableIntegrationId) {
			fetchHandHistory(0,undefined,undefined,undefined,undefined)
		} else {
			return createAction(CLEAR_TABLE_SESSION, {})
		}


	}
}
function _goToNextHand() {
	return (dispatch, getState : () => ApplicationState) => {

		var historyState = getState().history
		if (historyState.updating == true) {
			return
		}
		var sessionIndex = historyState.sessionIndex
		var handIndex = historyState.activeHandIndex
		var sessions = historyState.sessions

		if (HandHistoryUtils.isLastHandInCurrentSession(sessionIndex, handIndex, sessions)) {
			if (!HandHistoryUtils.isLastLoadedSession(sessionIndex, sessions) ){
				let newSessionIndex = sessionIndex + 1
				dispatch(selectHand(0, sessions[newSessionIndex].hands[0], newSessionIndex) as any)
			} else {
				if (historyState.hasNextPage) {
					goToNextPage(0,0)
				}
			}
		} else {
			let newHandIndex = handIndex + 1
			dispatch(selectHand(newHandIndex, sessions[sessionIndex].hands[newHandIndex], sessionIndex) as any)

		}
	}
}
function _goToPreviousHand() {
	return (dispatch, getState : () => ApplicationState) => {

		var historyState = getState().history
		if (!historyState.hasPreviousHand || historyState.updating) {
			return
		}
		var sessionIndex = historyState.sessionIndex
		var handIndex = historyState.activeHandIndex
		var sessions = historyState.sessions

		if (HandHistoryUtils.isFirstHandInSession(handIndex)) {

			if (!HandHistoryUtils.isFirstSessionLoaded(sessionIndex)){

				var newSessionIndex = sessionIndex-1
				var newHandIndex = sessions[newSessionIndex].hands.length - 1 // Move to last hand of previous session.
				dispatch(selectHand(newHandIndex, sessions[newSessionIndex].hands[newHandIndex], newSessionIndex))

			} else if (!HandHistoryUtils.isFirstPage(historyState.previousPages)) {
				goToPreviousPage(Number.MAX_VALUE,Number.MAX_VALUE)
			}
		} else {
			var newHandIndex = handIndex-1
			dispatch(selectHand(newHandIndex, sessions[sessionIndex].hands[newHandIndex], sessionIndex))
		}
	}
}

export interface SelectHandAction {
    activeHand : HistoricHand;
    activeHandIndex : number;
    sessionIndex: number;
}
export function  selectHand (index, hand, sessionIndex) : ReduxAction<SelectHandAction> {
	return createAction(SELECT_HAND,{ activeHand : hand, activeHandIndex : index, sessionIndex : sessionIndex})
}

export interface SelectHandDetailAction {
	activeHandDetail: HistoricHand;
}

export function  selectHandDetail (hand: HistoricHand): ReduxAction<SelectHandDetailAction> {
	return createAction(SELECT_HAND_DETAIL, { activeHandDetail: hand })
}

function _fetchTableServerHandHistory(startTime? : number, tableIntegrationId? : string, descending : boolean = true, nextHandIndex? : number, nextSessionIndex? : number) {
	return (dispatch, getState : () => ApplicationState) => {
		let historyState = getState().history
		if (historyState.updating) {
			return
		}

		let currency = appCtx.getToolbarManager().selectedCurrency
		dispatch(requestHandHistory(descending, startTime, nextHandIndex, nextSessionIndex, tableIntegrationId))
		PlayerApi.getTableServerHandHistory(currency, PAGE_COUNT, startTime, tableIntegrationId, descending, (data: HandHistoryList) => {
			dispatch(receiveHandHistory(data))
		}, () => {
			dispatch(receiveHandHistoryError())
		})
	}
}

function _fetchTableServerHandHistoryDetail(handId: string) {
	return (dispatch, getState : () => ApplicationState) => {
		let historyState = getState().history
		if (historyState.updating) {
			return
		}
		PlayerApi.getTableServerHandHistoryDetail(
			handId,
			(hand) => {
				dispatch(selectHandDetail(hand))
		}, () => {
			dispatch(receiveHandHistoryError())
		})
	}
}

function requestHandHistory(descending : boolean, startTime : number, nextHandIndex : number, nextSessionIndex : number, tableIntegrationId : string) : ReduxAction<HandHistoryRequest> {
	return createAction(REQUEST_HAND_HISTORY, {
		descending: descending,
		startTime: startTime,
		nextHandIndex: nextHandIndex,
		nextSessionIndex: nextSessionIndex,
		tableIntegrationId : tableIntegrationId

	})
}
function receiveHandHistory(history : HandHistoryList) : ReduxAction<HandHistoryList> {
	return createAction(RECEIVE_HAND_HISTORY, history)
}
function receiveHandHistoryError() : ReduxAction<{}> {
	return createAction(RECEIVE_HAND_HISTORY_ERROR, {})
}
